import { fetchAuthSession } from 'aws-amplify/auth'

export async function getAuthorizationToken() {
  const schedulerToken = localStorage.getItem('schedulerToken')
  if (schedulerToken) {
    return `scheduler:${schedulerToken}`
  }

  const session = await fetchAuthSession()
  const token = session.tokens?.idToken?.toString()

  if (!token) {
    const err = new Error('No current user')
    err.code = 'NotAuthorizedException'
    throw err
  }

  return token
}
